import { useIsSubtleBrand, useScaffold } from "@Light/scaffold";
import { clsx } from "clsx";
import React from "react";

export function useDefaultHeaderTitle(): React.ReactNode {
  const scaffold = useScaffold();
  const isSubtle = useIsSubtleBrand();
  if (isSubtle) {
    return null;
  }
  const HeaderLogo = scaffold.page.header.headerLogo;
  return HeaderLogo ? <HeaderLogo /> : scaffold.page.companyName;
}

export type MenuHeaderTitleProps = React.ComponentProps<"span"> & {};

export const MenuHeaderTitle: React.FC<MenuHeaderTitleProps> = React.forwardRef<
  HTMLElement,
  MenuHeaderTitleProps
>(({ children, className, ...props }, ref) => {
  const scaffold = useScaffold();
  const defaultTitle = useDefaultHeaderTitle();
  return (
    <span
      ref={ref}
      {...props}
      className={clsx(
        "text-lg font-medium",
        scaffold.page.colors.text.primary,
        className,
      )}
    >
      {children ?? defaultTitle}
    </span>
  );
});
